import { Button, Table,Spin, Modal, Form, Input, Select} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Col, Row } from 'react-bootstrap';
import {CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import {AUTH_URL} from '../constants';
import {IInterestrate, IPaymentPeriod} from '../factory/interfaces'
import { IoEnterSharp } from "react-icons/io5"
import { notify, notify_success, toastStyle } from '../pages/LoginPage';
import { selectUserDetails } from '../features/auth/authSlice';
import { useSelector } from 'react-redux';
import { getMetaData } from '../actions/metaActions';


const InterestRatesTable = () => {
    const dispatch = useDispatch()
    const [showExpenseForm, setShowExpenseForm] = useState(false)
    const [addingExpense, setAddingExpense] = useState(false)
    const [reloadComponent, setReloadComponent] = useState(false)
    const [paymentPeriods, setPaymentPeriods] = useState<IPaymentPeriod[]>()
    const [interestRates, setInterestrates] = useState<IInterestrate[]>()

    const [form] = Form.useForm()

     //Redux states
    const userDetails = useSelector(selectUserDetails)
    const isAdmin = userDetails?.role === 'admin'
    const metadata = useSelector((state: any) => state.metadata)

    //Functions

 const columns = [
    {
    title: 'No.',
    dataIndex: 'count',
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Value (%)',
    dataIndex: 'value',
    key: 'value',
  },
  {
    title: 'Payment period',
    dataIndex: 'payment_period',
    key: 'payment_period',
  },
  {
    title: 'Date of creation',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },

];

  const handleClose = ()=>{
    setShowExpenseForm(false)
    form.resetFields()
    }
  const showForm = ()=>setShowExpenseForm(true)


    const getInterestrates = async()=>{
      const response = await axios.get(`${AUTH_URL}/meta/interest-rates`, {withCredentials: true})
      if(response.data.success){
        setInterestrates(response.data.interest_rates)
      }

    }

    const registerInterestRate = async()=>{
      setAddingExpense(true)
      const expenseData = {
        value: form.getFieldValue('value'),
        payment_period: form.getFieldValue('payment_period'),
      }
      const response = await axios.post(`${AUTH_URL}/meta/interest-rates`, expenseData, {withCredentials: true})
      setAddingExpense(false)
      if(response.data.success){
        notify_success(`${response.data.message}`, toastStyle)
        form.resetFields()
        handleClose()
        setReloadComponent(true)
      }else{
        notify(`${response.data.message}`, toastStyle)

      }
    }

 useEffect(() => {
    if (metadata?.data?.success) {
      setPaymentPeriods(metadata.data.meta_data.payment_periods)
    }
  }, [metadata])

  useEffect(()=>{
    if(reloadComponent){
        getInterestrates()
        setReloadComponent(false)
    }
}, [reloadComponent])

  useEffect(()=>{
    getInterestrates()
    dispatch(getMetaData() as any)

  }, [dispatch])


  return (
    <>
    {interestRates? 
    <>

    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         </Col>
         <Col className='text-end py-2'>
            <Button type='primary' onClick={showForm} className='rounded-0 mx-1 text-uppercase small'> <IoEnterSharp style={{marginRight: '5px'}} /> <span>Register Interest Rate</span></Button>
         </Col>
        </Row>
    
     {
      interestRates &&
      <Table pagination={false} className='rounded-0 transactions-table' id='dlms-expenses-data' bordered dataSource={interestRates} columns={columns} 
       />
     }
     
      </> : 
        <Spin style={{paddingTop: 100}} tip="Loading interest rates..." size="large">
        <div className="content" />
      </Spin>

    }
   
      <Modal
      width={600} open={showExpenseForm} onCancel={handleClose}
         title={`REGISTER NEW INTEREST RATE`}
         centered
         footer={[
                     [

                      ]
                ]}
      >
      <Form
          layout="vertical"
          form={form}
          onFinish={registerInterestRate}

          >
          <Form.Item 
          label="Interest rate value in %"
          name="value"
          rules={[{ required: true, message: "Value is required" }]}
          tooltip='Enter value as a percentage. Should be less than 1'
          >
              <Input placeholder='Enter value' style={{width: '100%'}} className='rounded-0'
                />
          </Form.Item>
          <Form.Item 
              label="Payment period"
              name="payment_period"
              rules={[{ required: isAdmin, message: "Payment period is required" }]}
              tooltip='Select the payment priod'
              >
                <Select
                  allowClear
                  placeholder="Select payement period"
                  style={{ width: '100%' }}
                  options={paymentPeriods?.map((period) => ({
                              value: period._id,
                              label: period.name,
                            }))}
                    ></Select>
              </Form.Item>
          <Row className='d-flex gap-4' style={{marginTop: '40px'}}>
          <Col className='d-flex'>
          <Button loading={addingExpense} htmlType="submit" type='primary' className='rounded-0 text-uppercase small' key="edit_user">
              <span><SaveOutlined style={{marginRight: '5px'}} /></span>
              
              {
              addingExpense ?
              'Registering Interest Rate...'
              :
              'Register Interest Rate'
              
              }
          </Button>
          <Button  className='rounded-0 small text-uppercase mx-3' key="cancel" onClick={handleClose}>
            <CloseOutlined />   Cancel
          </Button>
          
          </Col>
          </Row>
          
        </Form>
      </Modal>
    </>
  )
}

export default InterestRatesTable